import { connect } from 'react-redux';
import EnrollUser from './EnrollUser';
import { addUser, removeUser, getCohortUsers } from '../../../actions/cohortActions';

export default connect(null, {
  addUser,
  removeUser,
  getCohortUsers,
})(EnrollUser);
